import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const profile = state.user.profile;

  if (isEmpty(profile)) {
    return undefined;
  }

  if (profile.invitationsReceived) {
    return profile.invitationsReceived;
  } else {
    return undefined;
  }
};
//VERIFY IF THE JWT IS SET
const getMyInvitationsReceivedCount = createSelector(getData, count => count);
export default getMyInvitationsReceivedCount;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyInvitationsReceivedCount.js